import { Component, OnInit } from '@angular/core';
import { CommonModule, LocationStrategy } from '@angular/common';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ApolloModule } from 'apollo-angular';
import { ToastsContainerComponent } from './core/components/toasts-container/toasts-container.component';
import { NgbModal, NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarService } from './core/services/progress-bar.service';
import * as Sentry from '@sentry/angular';
import { GoogleMapsLoaderService } from './core/services/google-maps-loader.service';
import { ApplicationService } from './core/services/application.service';
import { MessagingService } from './core/services/messaging.service';

@Component({
  selector: 'pegasus-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ApolloModule,
    ToastsContainerComponent,
    NgbProgressbar,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'pegasus-ui';
  progress = this.progressBarService.progress;
  loading = this.progressBarService.loading;

  constructor(
    private applicationService: ApplicationService,
    private progressBarService: ProgressBarService,
    trace: Sentry.TraceService,
    private googleMapsLoaderService: GoogleMapsLoaderService,
    private router: Router,
    private modalService: NgbModal,
    private locationStrategy: LocationStrategy,
    private messagingService: MessagingService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.modalService.hasOpenModals()) {
          this.locationStrategy.pushState(null, '', this.router.url, '');
          this.modalService.dismissAll(); // Optionally close the modal
        }
      }
    });
  }

  ngOnInit() {
    const userId = localStorage.getItem('userId') ?? ''; 
    
    if (userId) {
      this.messagingService.requestPermission(userId);
    }
  }
}
